module.exports = __webpack_public_path__ + "static/map-a34cfbf3f08bf7d0dd30ea187f7f01fd.jpg";